import { booleanAttribute, Component, EventEmitter, Input, Optional, Output } from '@angular/core';
import { ControlValueAccessor, NgControl, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { SecurityHolding } from '@models/shares/security-holding';
import {
  ShareClassTypeLabelComponent
} from '@shared/components/grid/ag-cells/shares/ag-share-class-type/share-class-type-label/share-class-type-label.component';
import { LinkComponent } from '@shared/components/commons/link/link.component';
import { ValidationErrorComponent } from '@shared/controls/validation-error/validation-error.component';
import { NgTemplateOutlet } from "@angular/common";

@Component({
  selector: 'app-share-security-holdings-dropdown',
  standalone: true,
  imports: [
    LinkComponent,
    ReactiveFormsModule,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    ValidationErrorComponent,
    ShareClassTypeLabelComponent,
    NgTemplateOutlet
  ],
  templateUrl: 'share-security-holdings-dropdown.component.html',
  styleUrl: 'share-security-holdings-dropdown.component.scss'
})
export class ShareSecurityHoldingsDropdownComponent implements ControlValueAccessor {
  @Input() width = '100%';
  @Input() placeholder = 'Select Share Type';
  @Input() label = 'Share Type';
  @Input() link = '';
  @Input() text = '';
  @Input() helperText = '';
  @Input() noOptionsText = 'There are no available shares.';
  @Input({ transform: booleanAttribute }) disabled = false;
  @Input({ transform: booleanAttribute }) hidePrice = false;
  @Input({ required: true, alias: 'options' }) set optionsSetter(value: SecurityHolding[]) {
    this.options = value;

    if (this._originValue) {
      this.writeValue(this._originValue);
    }
  }

  @Output() select = new EventEmitter<SecurityHolding>();
  @Output() addShareType = new EventEmitter<SecurityHolding>();

  private _originValue: string | null = null;

  #value: SecurityHolding | null = null;
  options: SecurityHolding[] = [];
  dropdownOpen = false;

  constructor(@Optional() protected ngControl: NgControl) {
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  get value(): SecurityHolding | null {
    return this.#value;
  }

  set value(value: SecurityHolding | null) {
    this.#value = value;
    this.onChange(this.#value?.securityHoldingId ?? null);
  }

  get displayValidationError(): boolean {
    return !!(this.ngControl && this.ngControl.touched && this.ngControl.errors);
  }

  selectOption(selectedOption: SecurityHolding): void {
    this.value = selectedOption;
    this.select.emit(selectedOption);
  }

  onChange: any = (): void => {
  };
  onTouched: any = (): void => {
  };

  writeValue(value: string): void {
    this._originValue = value;
    this.value = this.options.find((securityHolding) => securityHolding.securityHoldingId === value) ?? null;
  }

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  getDropdownState(dropdownState: boolean): void {
    this.dropdownOpen = dropdownState;
  }
}
